import { IconButton, IIconButtonProps } from 'components/action';
import { observable } from 'mobx';
import { observer } from 'mobx-react';
import * as React from 'react';
import { CSSTransitionGroup } from 'react-transition-group';

// Styles
const s = require('./Modal.css');
const closeIcon = require('assets/close orange icon.svg');

// Interfaces
export interface IModalIconButton extends IIconButtonProps {
    key: string;
    onClickCloseModal?: boolean;
}

// Props
interface IModalProps {
    show?: boolean;
    title?: string;
    titleBarContent?: JSX.Element;
    titleBarIcons?: IModalIconButton[];
    closeModalOnBackgroundClick?: boolean;
    onModalClose?: () => void;
}

@observer
export class Modal extends React.Component<IModalProps, {}> {
    static get defaultProps(): IModalProps {
        return {
            show: false,
            title: null,
            onModalClose: null,
            closeModalOnBackgroundClick: true,
            titleBarContent: null,
            titleBarIcons: [
                {
                    key: 'default-close-icon',
                    onClick: null,
                    onClickCloseModal: true,
                    label: 'Close',
                    icon: closeIcon,
                },
            ],
        };
    }

    constructor(props: IModalProps) {
        super(props);

        if (this.props.show) {
            setTimeout(() => {
                this.showModal();
            }, 256);
        }
    }

    private enterAnimationTime: number = 700;
    private leaveAnimationTime: number = 500;

    @observable private show: boolean = false;

    public componentWillUpdate(nextProps: IModalProps) {
        if (this.props.show !== nextProps.show) {
            setTimeout(() => {
                if (nextProps.show) {
                    this.showModal();
                } else {
                    this.hideModal();
                }
            }, 128);
        }
    }

    public render() {
        return (
            <CSSTransitionGroup
                component="div"
                transitionName="modal"
                transitionAppear={true}
                transitionAppearTimeout={this.enterAnimationTime}
                transitionEnter={true}
                transitionEnterTimeout={this.enterAnimationTime}
                transitionLeave={true}
                transitionLeaveTimeout={this.leaveAnimationTime}
            >
                {this.show && (
                    <div
                        className={s.background}
                        onClick={this.handleBackgroundClick}
                    >
                        <div className={s.wrapper}>
                            <div
                                className={s.container}
                                onClick={this.handleContainerClick}
                            >
                                <div className={s.titleBar}>
                                    <h5 className={s.titleBarHeadline}>
                                        {this.props.title || ''}
                                    </h5>

                                    {this.props.titleBarContent && (
                                        <div className={s.titleBarContent}>
                                            {this.props.titleBarContent}
                                        </div>
                                    )}

                                    <div className={s.titleBarIcons}>
                                        {this.props.titleBarIcons.map(
                                            (iconButton, i) => {
                                                return (
                                                    <IconButton
                                                        key={iconButton.key}
                                                        className={
                                                            typeof iconButton.className !==
                                                            'undefined'
                                                                ? iconButton.className
                                                                : null
                                                        }
                                                        iconClassName={
                                                            typeof iconButton.iconClassName !==
                                                            'undefined'
                                                                ? iconButton.iconClassName
                                                                : null
                                                        }
                                                        onClick={this.handleIconButtonClick(
                                                            i
                                                        )}
                                                        label={
                                                            typeof iconButton.label !==
                                                            'undefined'
                                                                ? iconButton.label
                                                                : undefined
                                                        }
                                                        icon={
                                                            typeof iconButton !==
                                                            'undefined'
                                                                ? iconButton.icon
                                                                : undefined
                                                        }
                                                        labelOnRight={false}
                                                        removePadding={true}
                                                    />
                                                );
                                            }
                                        )}
                                    </div>
                                </div>

                                {typeof this.props.children !== 'undefined' &&
                                    this.props.children && (
                                        <div className={s.content}>
                                            {this.props.children}
                                        </div>
                                    )}
                            </div>
                        </div>
                    </div>
                )}
            </CSSTransitionGroup>
        );
    }

    private showModal = () => {
        this.show = true;
        document.documentElement.style.overflow = 'hidden';
    };

    private hideModal = () => {
        this.show = false;

        setTimeout(() => {
            document.documentElement.style.overflow = null;
        }, this.leaveAnimationTime);

        if (this.props.onModalClose) {
            this.props.onModalClose();
        }
    };

    private handleContainerClick = (e: React.MouseEvent<HTMLDivElement>) => {
        e.stopPropagation();
    };

    private handleBackgroundClick = (e: React.MouseEvent<HTMLDivElement>) => {
        if (this.props.closeModalOnBackgroundClick) {
            this.hideModal();
        }
    };

    private handleIconButtonClick = (iconButtonIndex: number) => (
        e: React.MouseEvent<HTMLButtonElement>
    ) => {
        const iconButton = this.props.titleBarIcons[iconButtonIndex];

        if (typeof iconButton.onClick === 'function') {
            iconButton.onClick(e);
        }

        if (iconButton.onClickCloseModal) {
            this.hideModal();
        }
    };
}



// WEBPACK FOOTER //
// ./node_modules/tslint-loader??ref--0!./app/web/src/components/content/Modal.tsx